import React from 'react'
import PropTypes from 'prop-types';
import MediaRecorderPolyfill from 'audio-recorder-polyfill';

class Recorder extends React.Component {

	start () {
		this.mediaRecorder.start()
	}

	stop () {
		this.mediaRecorder.stop()
	}

	pause () {
		this.mediaRecorder.pause()
	}

	resume () {
		this.mediaRecorder.resume()
	}

	componentDidMount () {
        this.isValid = true;
		const constraints = {audio: true};
		navigator.getUserMedia = (navigator.getUserMedia ||
		navigator.mozGetUserMedia ||
		navigator.msGetUserMedia ||
		navigator.webkitGetUserMedia);
		const { blobOpts, onStop, onError, mediaOpts, onPause, onResume, onStart, gotStream } = this.props;


		const onErr = err => {
			console.warn(err);
			if (onError) onError(err)
		};

		if (!window.MediaRecorder) {
			window.MediaRecorder = MediaRecorderPolyfill;
		}


		if (navigator.mediaDevices) {
			let self = this;
			const onSuccess = stream => {
				self.mediaRecorder = new window.MediaRecorder(stream, mediaOpts || {});


				self.mediaRecorder.addEventListener('dataavailable', e => {
					onStop(e.data)
				});

				self.mediaRecorder.addEventListener('onstop', e => {
					onStop(e.data)
				});


				self.mediaRecorder.onerror = onErr;
				if (onPause) self.mediaRecorder.onpause = onPause;
				if (onResume) self.mediaRecorder.onresume = onResume;
				if (onStart) self.mediaRecorder.onstart = onStart;
				self.stream = stream;
				if (gotStream) gotStream(stream)
			};


			window.MediaRecorder = MediaRecorderPolyfill;
			navigator.mediaDevices.getUserMedia({audio: true}).then(onSuccess);

		}
		else
		{


		if (navigator.getUserMedia && window.MediaRecorder) {

			this.chunks = [];


			const onSuccess = stream => {
				this.mediaRecorder = new window.MediaRecorder(stream, mediaOpts || {});

				this.mediaRecorder.ondataavailable = e => {
					this.chunks.push(e.data)
				};

				this.mediaRecorder.onstop = e => {
					const blob = new window.Blob(this.chunks, blobOpts || {type: 'audio/wav'});
					this.chunks = [];
					onStop(blob)
				};

				this.mediaRecorder.onerror = onErr;
				if (onPause) this.mediaRecorder.onpause = onPause;
				if (onResume) this.mediaRecorder.onresume = onResume;
				if (onStart) this.mediaRecorder.onstart = onStart;
				this.stream = stream;
				if (gotStream) gotStream(stream)
			};

			navigator.getUserMedia(constraints, onSuccess, onErr)
		} else {
			console.warn('Audio recording APIs not supported by this browser');
			const { onMissingAPIs } = this.props;
			if (onMissingAPIs) {
				onMissingAPIs(navigator.getUserMedia, window.MediaRecorder)
			} else {
                this.isValid = false;
				window.alert('Your browser doesn\'t support native microphone recording. For best results, we recommend using Google Chrome or Mozilla Firefox to use this site.')
			}
		}
	}


	}

	componentDidUpdate (prevProps) {
		if (this.props.command && this.props.command !== 'none' && prevProps.command !== this.props.command && this.isValid == true) {
			this[this.props.command]()
		}
	}

	componentWillUnmount () {
		if (this.props.onUnmount) this.props.onUnmount(this.stream)
	}

	render () {
		return false
	}
}

Recorder.propTypes = {
	command: PropTypes.oneOf(['start', 'stop', 'pause', 'resume', 'none']),
	onStop: PropTypes.func.isRequired,
	onMissingAPIs: PropTypes.func,
	onError: PropTypes.func,
	onPause: PropTypes.func,
	onStart: PropTypes.func,
	onResume: PropTypes.func,
	onUnmount: PropTypes.func,
	gotStream: PropTypes.func,
	blobOpts: PropTypes.object,
	mediaOpts: PropTypes.object
};

export default Recorder